module.exports = __webpack_public_path__ + "img/bot_bdsh3.3ca6cdad.png";